import WXJsBridge from "@xes/wxjsbridge";

export function loginPopUp(_this) {
  // 如果APP内
  if (_this.$isInApp) {
    try {
      if (_this.isLogin) {
        _this.$nextTick(() => {
          // 页面重新出现时
          window.webOnResume = () => {
            location.reload();
          };
          window.location.href = "xeswangxiao://xrsApp?m=personals/setting";
        });
      } else {
        WXJsBridge.openLoginPage(
          {
            // autoReload  登录后是否需要自动刷新 0否 1是(默认)
          },
          (err, res) => {
            if (+res?.status === 1) {
              _this.SET_ISLOGIN(true);
            }
          }
        );
      }
    } catch (error) {
      alert(error.message);
    }
  } else {
    // 见 https://wiki.zhiyinlou.com/pages/viewpage.action?pageId=164883089
    const currentURL = encodeURIComponent(window.location.href);
    window.location.href = `https://login.xueersi.com/?redirect_url=${currentURL}`;
  }
}

export function logout() {
  const url = encodeURIComponent(window.location.href);
  const loginUrl = encodeURIComponent(
    `https://login.xueersi.com/?from=touch&redirect_url=${encodeURIComponent(
      url
    )}`
  );
  window.location.replace(
    `https://login.xueersi.com/newLogin/logout/?redirect_url=${encodeURIComponent(
      loginUrl
    )}`
  );
}
